import { fromJS, List, Map, Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateDisplayRecord } from "../shared/DateDisplayRecord";
import { TimespanDisplayRecord } from "../shared/TimespanDisplayRecord";

export const InspectorItemRecord = Record({
  // Normal properties of Item
  id: "",
  type: "",
  super: "",
  displayId: "",
  label: "",
  shortLabel: null,
  summary: "",
  initials: "",
  // Named Color ID, or swatch color (both acceptable)
  color: "",
  // Swatch Color
  swatchColor: "",
  ongoing: false,
  hasOngoingDescendants: false,
  startDate: DateDisplayRecord(),
  endDate: DateDisplayRecord(),
  duration: TimespanDisplayRecord(),
  preferredStartDate: DateDisplayRecord(),
  latestStartDate: null,
  earliestEndDate: null,
  preferredEndDate: DateDisplayRecord(),
  durationToEarliestEnd: null,
  preferredDuration: TimespanDisplayRecord(),
  isDateLocked: false,
  showAnniversary: false,
  anniversaryIcon: "markerOther",
  narrativePosition: List(),
  narrativeLabel: null,
  narrativeAutoLabel: null, // the manual or auto section type
  narrativeDisplayLabel: null,
  narrativePathLabel: null,
  isInNarrative: null,
  relationshipsByRefType: Map(),
  inverseRelationshipsByRefType: Map(),
  blockingDependencies: List(),
  blockedByDependencies: List(),
  dateConstraints: List(),
  propertyValues: Map(),
  tags: List(),
  hasChildren: false,
  children: List(),
  image: null,
  attachments: List(),
  links: List(),
  locationUri: null,
  hasDates: false
});

createFromJS.registerCallback("InspectorItemRecord", any => {
  return new InspectorItemRecord(fromJS(any)).withMutations(o => {
    // Update timestamp and timespan
    o.update("startDate", val => createFromJS.DateDisplayRecord(val));
    o.update("endDate", val => createFromJS.DateDisplayRecord(val));
    o.update("duration", val => createFromJS.TimespanDisplayRecord(val));
    o.update("preferredStartDate", val => createFromJS.DateDisplayRecord(val));
    o.update("latestStartDate", val => (val ? createFromJS.DateDisplayRecord(val) : null));
    o.update("earliestEndDate", val => (val ? createFromJS.DateDisplayRecord(val) : null));
    o.update("preferredEndDate", val => createFromJS.DateDisplayRecord(val));
    o.update("durationToEarliestEnd", val => (val ? createFromJS.TimespanDisplayRecord(val) : null));
    o.update("preferredDuration", val => createFromJS.TimespanDisplayRecord(val));
    // And now update the reference list
    o.update("relationshipsByRefType", val => val.map(l => l.map(o => createFromJS.InspectorRelationshipRecord(o))));
    // And the narrative position
    o.update("narrativePosition", val => List(val));
  });
});
